import { render, staticRenderFns } from "./PersonSelectorCard.vue?vue&type=template&id=3ee3620d&scoped=true"
import script from "./PersonSelectorCard.vue?vue&type=script&lang=js"
export * from "./PersonSelectorCard.vue?vue&type=script&lang=js"
import style0 from "./PersonSelectorCard.vue?vue&type=style&index=0&id=3ee3620d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee3620d",
  null
  
)

export default component.exports